<div class="general-settings d-sm-flex flex-column" [formGroup]="settingsForm">
    <h3>Task Options</h3>
    <!-- Instructions Field -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Instructions</mat-label>
        <textarea matInput formControlName="instructions" placeholder="Enter instructions" rows="5"></textarea>
    </mat-form-field>

    <!-- Model Selection -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Model</mat-label>
        <mat-select formControlName="model">
            @for (modelOption of modelOptions; track modelOption) {
                <mat-option [value]="modelOption">
                    {{ modelOption }}
                </mat-option>
            }
        </mat-select>
        @if (legacyModel; as legacyModel) {
            <mat-hint>Current model: {{ legacyModel }} (legacy)</mat-hint>
        }
    </mat-form-field>

    <!-- Response Type -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Response Type</mat-label>
        <mat-select formControlName="responseType" placeholder="Select response type">
            <mat-option [value]="'text'">Text</mat-option>
            <mat-option [value]="'json'">JSON</mat-option>
            <mat-option [value]="'audio'">Audio</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Reasoning Effort Field -->
    @if (settingsForm.get('model')?.value === 'o3-mini') {
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Reasoning Effort</mat-label>
            <mat-select formControlName="reasoningEffortLevel" placeholder="Select reasoning level">
                <mat-option [value]="'Low'">Low</mat-option>
                <mat-option [value]="'Medium'">Medium</mat-option>
                <mat-option [value]="'High'">High</mat-option>
            </mat-select>
    </mat-form-field>
    }

    <!-- Temperature Field -->
    @if (settingsForm.get('model')?.value !== 'o3-mini') {
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Temperature</mat-label>
            <input formControlName="temperature" matInput type="number">
    </mat-form-field>
    }
</div>
